/* Love & Family Co. — theme effects */
(function () {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  document.querySelectorAll('.section-head, .collection-card, .product-card, .review-card, .promo, .about__inner, .hero__copy, .hero__media')
    .forEach(function (el) { if (!el.classList.contains('reveal')) { el.classList.add('reveal'); io.observe(el); } });

  var header = document.getElementById('header');
  if (header) addEventListener('scroll', function () { header.classList.toggle('is-stuck', scrollY > 8); });

  document.querySelectorAll('.wish').forEach(function (b) {
    b.addEventListener('click', function (ev) { ev.preventDefault(); b.classList.toggle('is-active'); });
  });

  var mm = document.getElementById('mobileMenu');
  var mmOverlay = document.getElementById('mobileOverlay');
  var burger = document.getElementById('burger');
  var mc = document.getElementById('menuClose');
  function mmOpen(){ if(mm) mm.classList.add('open'); if(mmOverlay) mmOverlay.classList.add('open'); document.body.style.overflow='hidden'; }
  function mmClose(){ if(mm) mm.classList.remove('open'); if(mmOverlay) mmOverlay.classList.remove('open'); document.body.style.overflow=''; }
  if (burger) burger.onclick = mmOpen;
  if (mc) mc.onclick = mmClose;
  if (mmOverlay) mmOverlay.onclick = mmClose;
  if (mm) {
    mm.querySelectorAll('.mm-link, .mm-sub a').forEach(function (a) { a.addEventListener('click', mmClose); });
    mm.querySelectorAll('.mm-toggle').forEach(function (t) { t.addEventListener('click', function () { t.closest('.mm-item').classList.toggle('open'); }); });
  }

  var tt = document.getElementById('toTop');
  if (tt) {
    addEventListener('scroll', function () { tt.classList.toggle('show', scrollY > 600); });
    tt.onclick = function () { scrollTo({ top: 0, behavior: 'smooth' }); };
  }

  var cd = document.getElementById('countdown');
  if (cd) {
    var days = parseInt(cd.getAttribute('data-days') || '2', 10);
    var hrs = parseInt(cd.getAttribute('data-hours') || '8', 10);
    var end = Date.now() + (days * 86400 + hrs * 3600) * 1000;
    var p = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var d = Math.floor(s / 86400); s %= 86400;
      var h = Math.floor(s / 3600); s %= 3600;
      var m = Math.floor(s / 60); s %= 60;
      var set = function (sel, v) { var el = cd.querySelector(sel); if (el) el.textContent = p(v); };
      set('[data-d]', d); set('[data-h]', h); set('[data-m]', m); set('[data-s]', s);
    };
    tick(); setInterval(tick, 1000);
  }
})();

/* Cart drawer + edit */
(function(){
  var drawer=document.getElementById('cartDrawer');
  var overlay=document.getElementById('cartOverlay');
  var body=document.getElementById('cartDrawerBody');
  var foot=document.getElementById('cartDrawerFoot');
  var editOverlay=document.getElementById('cdEditOverlay');
  var editModal=document.getElementById('cdEdit');
  if(!drawer||!overlay||!body||!foot) return;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
  function money(c){ return '$'+(c/100).toFixed(2); }
  function esc(s){ var d=document.createElement('div'); d.textContent=s==null?'':s; return d.innerHTML; }
  function img(u,w){ if(!u) return ''; return u+(u.indexOf('?')>-1?'&':'?')+'width='+(w||140); }
  /* Line item properties (dữ liệu custom khách nhập) -> HTML */
  function propsHtml(props){
    if(!props) return '';
    var out='';
    Object.keys(props).forEach(function(k){
      if(!k || k.charAt(0)==='_') return;             /* key bắt đầu bằng _ là field ẩn */
      var val=props[k];
      if(val===null||val===undefined||val==='') return;
      val=String(val);
      if(/^(https?:)?\/\//.test(val)){
        var isImg=/\.(png|jpe?g|gif|webp|svg)(\?|$)/i.test(val);
        var nm=val.split('?')[0].split('/').pop();
        out+='<span class="li-prop">'
            +(isImg?'<img class="li-prop__thumb" src="'+esc(val)+'" alt="" loading="lazy">':'')
            +'<b>'+esc(k)+':</b> <a href="'+esc(val)+'" target="_blank" rel="noopener">'+esc(decodeURIComponent(nm))+'</a></span>';
      } else {
        out+='<span class="li-prop"><b>'+esc(k)+':</b> '+esc(val)+'</span>';
      }
    });
    return out?'<span class="li-props">'+out+'</span>':'';
  }
  function open(){ drawer.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow='hidden'; }
  function close(){ drawer.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow=''; }
  var PENCIL='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
  var TRASH='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M6 6l1 14h10l1-14"/></svg>';
  function render(cart){
    document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent=cart.item_count; });
    if(!cart.items||cart.item_count===0){
      body.innerHTML='<p class="cd-empty">Your cart is empty.</p>';
      foot.innerHTML='<a class="btn cd-checkout" href="'+root+'collections/all">Start shopping</a>';
      return;
    }
    var h='';
    cart.items.forEach(function(it){
      var vt=(it.variant_title&&it.variant_title!=='Default Title')?it.variant_title:'';
      var props=propsHtml(it.properties);
      h+='<div class="cd-item" data-key="'+esc(it.key)+'" data-handle="'+esc(it.handle)+'" data-vid="'+it.variant_id+'" data-qty="'+it.quantity+'">'
        +'<a href="'+it.url+'" class="cd-item__img"><img src="'+img(it.image)+'" alt=""></a>'
        +'<div class="cd-item__info"><a href="'+it.url+'" class="cd-item__title">'+esc(it.product_title)+'</a>'
        +'<span class="cd-item__variant">'+(vt?esc(vt)+' &middot; ':'')+'Qty '+it.quantity+'</span>'
        +props
        +'<div class="cd-price-actions"><span class="cd-item__price">'+money(it.final_line_price)+'</span>'
        +'<div class="cd-actions">'
        /* Sản phẩm custom: bỏ nút Edit vì sửa biến thể sẽ làm mất text/ảnh khách đã nhập */
        +(props?'':'<button type="button" class="cd-icon" data-cd-edit aria-label="Edit">'+PENCIL+'</button>')
        +'<button type="button" class="cd-icon cd-icon--danger" data-cd-remove aria-label="Remove">'+TRASH+'</button>'
        +'</div></div></div></div>';
    });
    body.innerHTML=h;
    foot.innerHTML='<div class="cd-subtotal"><span>Subtotal</span><b>'+money(cart.total_price)+'</b></div>'
      +'<a class="btn btn--accent btn--lg cd-checkout" href="'+root+'checkout">Checkout</a>'
      +'<a class="cd-viewcart" href="'+root+'cart">View full cart</a>';
  }
  function fetchCart(){ return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ render(c); return c; }); }
  function change(key,qty){ return fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(render); }
  function addVariant(id,qty){ return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:qty})}).then(function(r){return r.json();}); }
  document.querySelectorAll('[data-cart-open]').forEach(function(a){ a.addEventListener('click',function(e){ e.preventDefault(); open(); fetchCart(); }); });
  overlay.addEventListener('click',close);
  document.querySelectorAll('[data-cart-close]').forEach(function(b){ b.addEventListener('click',close); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeEdit(); close(); } });
  body.addEventListener('click',function(e){
    var item=e.target.closest('.cd-item'); if(!item) return; var key=item.getAttribute('data-key');
    if(e.target.closest('[data-cd-remove]')){ change(key,0); }
    else if(e.target.closest('[data-cd-edit]')){ openEdit(item); }
  });
  document.querySelectorAll('form[action$="/cart/add"]').forEach(function(f){
    f.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=f.querySelector('[type="submit"]'); if(btn) btn.disabled=true;
      fetch(root+'cart/add.js',{method:'POST',body:new FormData(f),headers:{'Accept':'application/json'}})
        .then(function(r){return r.json();}).then(function(){ if(btn)btn.disabled=false; open(); fetchCart(); })
        .catch(function(){ if(btn)btn.disabled=false; f.submit(); });
    });
  });
  // ---- edit modal ----
  var editState=null;
  function closeEdit(){ if(editModal)editModal.classList.remove('open'); if(editOverlay)editOverlay.classList.remove('open'); }
  function optName(o){ return (typeof o==='object'&&o!==null)?o.name:o; }
  function openEdit(item){
    if(!editModal||!editOverlay) return;
    var handle=item.getAttribute('data-handle');
    var vid=parseInt(item.getAttribute('data-vid'),10);
    var qty=parseInt(item.getAttribute('data-qty'),10);
    var key=item.getAttribute('data-key');
    fetch(root+'products/'+handle+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(prod){
      editState={product:prod,key:key,oldVid:vid};
      buildEdit(prod,vid,qty);
      editModal.classList.add('open'); editOverlay.classList.add('open');
    });
  }
  function buildEdit(prod,vid,qty){
    var cur=null; for(var i=0;i<prod.variants.length;i++){ if(prod.variants[i].id===vid){ cur=prod.variants[i]; break; } }
    var curOpts=cur?cur.options:[];
    var h='<button type="button" class="cd-edit__close" data-cd-edit-close aria-label="Close"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
    var imsrc=(cur&&cur.featured_image?cur.featured_image.src:prod.featured_image);
    h+='<div class="cd-edit__head"><img class="cd-edit__img" src="'+img(imsrc,240)+'" alt=""><div><h3 class="cd-edit__title">'+esc(prod.title)+'</h3><div class="cd-edit__price">'+money(cur?cur.price:prod.price)+'</div></div></div>';
    prod.options.forEach(function(op,oi){
      var vals=[]; prod.variants.forEach(function(v){ if(vals.indexOf(v.options[oi])<0) vals.push(v.options[oi]); });
      if(vals.length===1&&vals[0]==='Default Title') return;
      h+='<div class="cd-edit__opt" data-oi="'+oi+'"><div class="cd-edit__opt-label">'+esc(optName(op))+'</div><div class="cd-pill-group">';
      vals.forEach(function(val){ h+='<button type="button" class="cd-pill'+(curOpts[oi]===val?' sel':'')+'" data-val="'+esc(val)+'">'+esc(val)+'</button>'; });
      h+='</div></div>';
    });
    h+='<div class="cd-edit__opt-label">Quantity</div><div class="cd-edit__qty"><button type="button" data-eq-dec aria-label="Decrease">−</button><span id="cdEditQty">'+qty+'</span><button type="button" data-eq-inc aria-label="Increase">+</button></div>';
    h+='<button type="button" class="btn btn--accent btn--lg cd-edit__update" data-cd-update>Update item &rarr;</button>';
    editModal.innerHTML=h;
  }
  if(editOverlay) editOverlay.addEventListener('click',closeEdit);
  if(editModal) editModal.addEventListener('click',function(e){
    if(e.target.closest('[data-cd-edit-close]')){ closeEdit(); return; }
    var pill=e.target.closest('.cd-pill');
    if(pill){ pill.parentNode.querySelectorAll('.cd-pill').forEach(function(p){p.classList.remove('sel');}); pill.classList.add('sel'); return; }
    var q=editModal.querySelector('#cdEditQty');
    if(e.target.closest('[data-eq-dec]')&&q){ q.textContent=Math.max(1,parseInt(q.textContent,10)-1); return; }
    if(e.target.closest('[data-eq-inc]')&&q){ q.textContent=parseInt(q.textContent,10)+1; return; }
    if(e.target.closest('[data-cd-update]')){ doUpdate(); return; }
  });
  function doUpdate(){
    if(!editState) return;
    var prod=editState.product;
    var sel=[]; editModal.querySelectorAll('.cd-edit__opt').forEach(function(o){ var oi=parseInt(o.getAttribute('data-oi'),10); var p=o.querySelector('.cd-pill.sel'); sel[oi]=p?p.getAttribute('data-val'):null; });
    var newVar=null;
    for(var i=0;i<prod.variants.length;i++){ var v=prod.variants[i]; var m=true; for(var j=0;j<v.options.length;j++){ if(sel[j]!=null&&v.options[j]!==sel[j]){ m=false; break; } } if(m){ newVar=v; break; } }
    var q=parseInt(editModal.querySelector('#cdEditQty').textContent,10);
    if(!newVar) return;
    closeEdit();
    if(newVar.id===editState.oldVid){ change(editState.key,q); }
    else { change(editState.key,0).then(function(){ return addVariant(newVar.id,q); }).then(fetchCart); }
  }
})();

/* Footer accordion (mobile only) */
(function(){
  var mq=window.matchMedia('(max-width: 760px)');
  document.querySelectorAll('.footer__col-title').forEach(function(t){
    t.addEventListener('click',function(){ if(mq.matches){ t.closest('.footer__col').classList.toggle('open'); } });
  });
})();
